/* bk-card-buy — syncs the Subscribe/One-time radios with the add-to-cart
   form (variant id + selling plan) and the price shown on the bar.
   The actual add-to-cart submit is handled by Dawn's product-form.js.

   Fix: the form is now synced to the initially-checked radio on load,
   not only on change. Previously, if the default radio carried a
   selling plan (or the product requires a selling plan), submitting
   without touching the radios sent no `selling_plan` param and Shopify
   rejected the add with a 422. */
if (!customElements.get('bk-card-buy')) {
  customElements.define(
    'bk-card-buy',
    class BkCardBuy extends HTMLElement {
      connectedCallback() {
        // Two-step add on touch devices: while collapsed, the first tap on the
        // bar reveals the purchase options instead of adding to cart.
        this.addEventListener(
          'click',
          (e) => {
            if (!this.classList.contains('bk-buy--collapsed')) return;
            if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
            const bar = e.target.closest('button[name="add"]');
            if (!bar) return;
            e.preventDefault();
            e.stopPropagation();
            this.classList.remove('bk-buy--collapsed');
          },
          true
        );

        this.addEventListener('change', (e) => {
          const radio = e.target.closest('input[name="bk_purchase"]');
          if (!radio || !radio.checked) return;
          this.syncFormToRadio(radio);
        });

        // Sync the form to whatever radio is checked at render time so the
        // hidden selling_plan input exists before the first submit.
        const checked = this.querySelector('input[name="bk_purchase"]:checked');
        if (checked) this.syncFormToRadio(checked);
      }

      syncFormToRadio(radio) {
        const form = this.querySelector('form');
        if (!form) return;

        const idInput = this.querySelector('input[name="id"]');
        if (idInput && radio.dataset.variantId) idInput.value = radio.dataset.variantId;

        let planInput = this.querySelector('input[name="selling_plan"]');
        if (radio.dataset.sellingPlan) {
          if (!planInput) {
            planInput = document.createElement('input');
            planInput.type = 'hidden';
            planInput.name = 'selling_plan';
            form.appendChild(planInput);
          }
          planInput.value = radio.dataset.sellingPlan;
        } else if (planInput) {
          planInput.remove();
        }

        const price = this.querySelector('[data-bk-buy-price]');
        if (price && radio.dataset.price) price.textContent = radio.dataset.price;
      }
    }
  );
}